// eslint-disable-next-line import/no-anonymous-default-export
export default {
  //Home Page
  recent: "Recent",
  trending: "Trending",
  active: "Active",
  fellows: "Fellows",
  prime: "Prime",
  business: "Business",
  book: "Book",
  lifestyle: "Lifestyle",
  testPrep: "Test Prep",
  viewAll: "See All",

  english: "English",
  french: "Français",

  en: "EN",
  fr: "FR",

  //Categories
  fellowCat: "Fellow's Category Classes",
  otherCat: "Other's Category Classes",
  businessCat: "Business's Category Classes",
  bookCat: "Book's Category Classes",
  testPrepCat: "Test Prep's Category Classes",
  lifestyleCat: "Lifestyle's Category Classes",

  //No data
  noData: "No Data",
  noCatAvailable: "No Categories available",
  noClasses: "No Classes for this Category",
  backToCat: "Back to Categories",
  noItem: "No item found",
  noCourses: "No Courses available",
  noTest: "No Test available",
  classNotFound: "Class is not found",
  DiscussionNotFound: "No discussions yet. Be the first to start one",
  backHome: "Back to Home",
  noContentProviderFound: "Content Provider is not found",
  backToContent: "Back to Content Providers",
  noClassInterest: "No Classes for this Interest",
  backToInterest: "Back to Interests",
  noInterest: "No Interests available",
  noPoints: "No Points available",
  getMorePoints: "Get more points by takes more Courses",
  noPaymentAvailable: "No Payment available",
  selectedAllInterest: "Selected All Interest",
  noClassAvailable: "No Class available",
  noComments: "No comments",
  noTopic: "No topics available",
  noTopicRP: "No Read or Practice topics available",
  noCourseFound: "Course is not found",
  noAnnouncement: "No Announcements available",
  noEvents: "No Events available",

  //Content ---- Providers
  noContentProviders: "No Content Providers available",
  contentProvider: "Content Provider",
  details: "Details",
  country: "Country",
  classes: "Classes",

  //Subscriptions
  allSubscription: "All Subscriptions",
  // subscribe: "Subscribe",
  subscribe: "Join this class for FREE",
  unSubscribe: "Unsubscribe",
  subscribed: "Subscribed",
  paid: "Paid",
  expired: "Expired",
  subscribeToView: "Subscribe to view course content",
  noSubscriptions: "No Subscriptions",

  // allSubscription: "All Subscriptions",
  join: "Join",
  joinClass: "Join this class for FREE",
  payJoinClass: "Pay to join this class",
  pay: "Pay",
  // unSubscribe: "Unsubscribe",
  // subscribed: "Subscribed",
  // paid: "Paid",
  // expired: "Expired",
  // subscribeToView: "Subscribe to view course content",
  // noSubscriptions: "No Subscriptions",

  //category --- class
  category: "Category",
  description: "Description",
  totalCourses: "Total Courses",
  courses: "Courses",
  test: "Tests",

  //Profile
  myProfile: "My Profile",
  profileDetails: "View personal profile details.",
  editProfile: "Edit Profile",
  firstName: "First Name",
  lastName: "Last Name",
  city: "City",
  institute: "Institute",
  changePass: "Change Password",
  oldPass: "Old Password",
  newPass: "New Password",
  confirmPass: "Confirm Password",
  deleteAccount: "Delete Account",
  about: "About Me",
  payment: "Payments",
  interest: "Interests",
  profile: "Profile ",
  username: "Username",
  gender: "Gender",
  genderSelect: "Select gender",
  genderMale: "Male",
  genderFemale: "Female",
  ecampusID: "eCampus ID",
  referralID: "Referral ID",
  totalPoints: "Total Points",
  updateProfile: "Update Your Profile",
  updateInterest: "Update Interests",
  yourInterests: "Your interests",
  selectInterestsFromBelow:
    "You have not selected any interests yet. Choose from the list below to add them.",
  allInterest: "All Interests",

  //Public pages
  freeClasses: "Free Classes",
  publicClasses: "Public Classes",
  paidClasses: "Paid Classes",
  jhsClasses: "JHS Classes",
  shsClasses: "SHS Classes",
  classesTopic: "Class Topic",

  //Buttons
  delete: "Delete",
  cancel: "Cancel",
  update: "Update",
  continue: "Continue...",
  save: "Save",
  submit: "Submit",
  post: "Post",
  resetPassword: "Reset Password",
  resetPasswordP:
    "Enter your email address and we'll send you an email with instructions to reset your password.",

  //Sub components
  startLearning: "Start Learning",
  duration: "Duration",
  startTest: "Start Test",
  takeTestNow: "Take a test now",
  takeTest: "Take a test",
  contentAdminTest: "Contact admin to subscribe you to this test",
  contentAdminCourse: "Contact admin to subscribe you to this class",
  subToStartLearn: "Join class to start learning",
  subToStartTest: "Join class to start test",
  topics: "Topics",
  totalTopics: "Total Topics",
  recentTopics: "Recent Topics",
  courseOutline: "Course Outline",

  //Discussions
  comments: "Comments",
  addDiscuss: "Add Discussion",

  //ToolTips
  read: "Read",
  listen: "Listen",
  practice: "Practice",
  watch: "Watch",
  discuss: "Discuss",

  //Aduios
  loading: "Loading",
  paused: "Paused",
  playing: "Playing",

  //auth Pages
  signIn: "Sign in",
  signUp: "Sign up",
  signOut: "Sign out",
  email: "E-mail",
  password: "Password",
  forgotPassword: "Forgot Password",
  noAccount: "Don't have an account",
  or: "or access quickly",
  signInGoogle: "Sign in with Google",
  signUpGoogle: "Sign up with Google",
  confirmPassword: "Confirm Password",
  passwordError: "Password must be 8 characters long",
  gotAnAccount: "Already Have Account",
  emailAddress: "Email address",
  login: "Login",

  //Main Page
  eStudents: "eCampus for Students",
  eStudentsP:
    "Learning just got easier. Set targets, take prep tests anytime and improve. No restrictions. Level up!",
  eTeacher: "eCampus for Teachers",
  eBusiness: "eCampus for Business",
  eBusinessP:
    "Keeping your workforce competitive in an ever-changing business world.",
  eTeacherP: "Become the human factor in the age of technology",

  //WhiteLabel
  announcement: "Announcement",
  announcementDetails: "Announcement Details",
  events: "Events",
  loadMore: "Load more",
  cpNotFound: "Content Provider is not found",

  searchHere: "What do you want to learn?",
  tellUsAboutYourself: "Tell us about yourself",
  home: "Home",
  contentProviders: "Content Providers",
  subscriptions: "My Classes",
  categories: "Categories",
  interests: "Interests",
  tests: "Tests",
  announcements: "Announcements",
  forum: "Forum",
  success: "Success",
  aMailHasBeenSend:
    "We've sent a password reset link to your email. Please check your inbox and follow the instructions to reset your password.",
  interestClasses: "Interest Classes",
  questions: "Questions",
  payToAccessContent: "Pay to access content",
  payNow: "Pay now",
  interestBased: "Based on your interests",
  sorryYouCannot: "Sorry you cannot access this content here",
  clickHereToAccessContent: "Click here to access content",
  signInTele: "Register with Telecel",
  telecelID: "Telecel ID",
  sendCode: "Send code",
  code: "Code",
  phoneNumber: "Phone number",
  accountNumber: "Account number",
  changePhoneNumber: "Change phone number",
  changeAccountNumber: "Change account number",
  signInUsernameEmail: "Sign in with username/email",
  signInUsernameEmailOthers: "Sign in with Username or Email or Telecel ID",
  dateTimeLanguage: "en-US",
  skip: "Skip",

  learningPartner: "Learning Partner",
  learningPartners: "Learning Partners",
  sections: "Sections",
  section: "Section",
  videos: "Videos",
  audios: "Audios",
  timedTests: "Timed Tests",
  minutes: "Minutes",
  practiceQuestions: "Practice Questions",
  whatYouGet: "What you get",
  totalSections: "Total Sections",
  skills: "Skills to be acquired",
  learningGoals: "Learning goals",
  aboutThisClass: "About this class",
  aboutThisLearningPartner: "About this Learning Partner",
  lastUpdated: "Last Updated",
  price: "Price",
  language: "Language",

  suggestedClasses: "Suggested Classes",
  recommendedClasses: "Recommended Classes",
  relatedCourses: "Related Courses",
  suggestedLearningPartners: "Suggested Learning Partners",
  yourProgress: "Your Progress",
  completed: "completed",
  complete: "complete",
  of: "of",
  progressPointsPrizesInfo:
    "Your progress while reading, watching or listening adds up to your total points, which can potentially allow you to access prizes once specified targets are hit.",

  // "Update Profile"
  settings: "Settings",
  points: "Points",
  deleteAccountMessage: "Are you sure you want to delete your account?",
  location: "Location",
  chooseimage: "Choose an image",
  searchResults: "Search results on",
  viewCertificate: "View Certificate",
  certificates: "Certificates",
  bundles: "Bundles",
};
